import { motion } from 'framer-motion';
import { X, AlertCircle, CheckCircle } from 'lucide-react';

export function Toast({ title, description, variant = 'default', onDismiss }) {
  const variants = {
    default: {
      bg: 'bg-white',
      icon: CheckCircle,
      iconColor: 'text-emerald-500',
      titleColor: 'text-gray-900',
      descriptionColor: 'text-gray-600'
    },
    destructive: {
      bg: 'bg-red-50',
      icon: AlertCircle,
      iconColor: 'text-red-500',
      titleColor: 'text-red-800',
      descriptionColor: 'text-red-600'
    }
  };

  const style = variants[variant];
  const Icon = style.icon;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className={`${style.bg} rounded-lg shadow-lg p-4 min-w-[300px] max-w-md flex gap-3 items-start`}
    >
      <Icon className={`w-5 h-5 ${style.iconColor} flex-shrink-0 mt-0.5`} />

      <div className="flex-1">
        {title && (
          <h3 className={`font-medium ${style.titleColor} text-sm`}>{title}</h3>
        )}
        {description && (
          <p className={`${style.descriptionColor} text-sm mt-1`}>
            {description}
          </p>
        )}
      </div>

      <button
        onClick={onDismiss}
        className="text-gray-400 hover:text-gray-600 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </motion.div>
  );
}
